module.exports = __webpack_public_path__ + "static/img/banner3.879d0e9.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/h5/banner3.webp
// module id = vSrM
// module chunks = 2